var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "nav-wrapper flex justify-between align-center"
  }, [_c("a-icon", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.horizontal,
      expression: "!horizontal"
    }],
    staticClass: "nav-fold boxHover",
    attrs: {
      type: _vm.collapsed ? "menu-fold" : "menu-unfold"
    },
    on: {
      click: _vm.toggleOpen
    }
  }), _c("bread-crumb", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.horizontal,
      expression: "!horizontal"
    }]
  }), _c("div", {
    staticClass: "right-menu flex"
  }, [_c("noticeCenter"), _vm.accountInfo.customerId != 0 ? _c("task-list") : _vm._e(), _c("nav-locale"), _c("nav-user", {
    staticClass: "right-menu-item pointer boxHover flex-sub"
  })], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };